import React, { useCallback, useState } from 'react';
import WisdomLearning from '../../../wisdom/WisdomLearning';
import { completeSession } from '../../api/activitySessions';

/**
 * WisdomSession - Wrapper for WisdomLearning that handles session completion
 */
export const WisdomSession = ({
  session,
  activity,
  onComplete
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleGameComplete = useCallback(async (gameResult) => {
    if (isSubmitting) return;

    setIsSubmitting(true);
    try {
      // Build final snapshot with completion data
      const finalSnapshot = {
        completed: true,
        total_score: gameResult.total_score,
        wisdoms: gameResult.wisdoms,
        mastered_wisdom_ids: gameResult.mastered_wisdom_ids
      };

      // Complete the session via API
      const result = await completeSession(session.id, finalSnapshot);

      if (result.status === 'success') {
        // Success - notify parent to refresh dashboard
        onComplete(result);
      } else {
        // Handle unexpected status
        console.error('Unexpected completion status:', result.status);
        alert(result.message || 'Failed to complete activity');
      }
    } catch (error) {
      console.error('Error completing session:', error);
      alert(error.message || 'Failed to complete activity');
    } finally {
      setIsSubmitting(false);
    }
  }, [session.id, onComplete, isSubmitting]);

  return (
    <WisdomLearning
      activityId={activity.id}
      sessionId={session.id}
      railsEnv={window.railsEnv || 'development'}
      onComplete={handleGameComplete}
    />
  );
};
